<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator';
import { useAppliedFiltersStore } from '@/domain/search/application/AppliedFilters.store';
import { useSearchResultsStore } from '@/domain/search/application/SearchResults.store';
import { Url } from 'webshop-modules/dom/Url';
import { TranslationService } from 'webshop-modules/translation/translation.service';
import { LanguageCode } from 'webshop-modules/translation/language-code.enum';
import { AppliedFilters } from '@/domain/search/entitites/applied-filters.interface';
import ArtistsSearchComponent from "@/components/artists-search/ArtistsSearch.vue";

@Component({
    name: 'ArtistsSearch',
    components: {
        ArtistsSearchComponent,
    },
})
export default class ArtistsSearch extends Vue {
    public headerKey = 0;
    public url: Url = new Url(window.location.href);
    public lang: string =
        TranslationService.getLanguageCode() !== LanguageCode.Slovenian ? TranslationService.getLanguageCode() : 'si';

    public created(): void {
        const params: AppliedFilters = { lang: this.lang };
        const appliedFilters = useAppliedFiltersStore();
        const searchResults = useSearchResultsStore();

        const letterParam = this.url.getSearchParam('letter');

        if (letterParam !== undefined) {
            params.searchText = decodeURIComponent(letterParam.replace(/#alphabet/g, ''));
        }

        appliedFilters.updateAppliedFilters(params);
        searchResults.getArtists(false, this.$apiService);
    }
}
</script>

<template>
    <ArtistsSearchComponent />
</template>
